import React, { Component } from 'react';
import { appImgAlt, routeAfterLogin } from '../config/Config';
import { Username } from '../helpers/User';
import { getTokenData, getUserData, setUserData, parseJwt, reactLoader } from '../helpers/Common';

// Assign $ value to use jquery
const $ = window.$;

export default class BirthdayWish extends Component {
    constructor(props) {
        super(props);
        let afterRoutes = getUserData("afterRoutes", true);
        this.state = {
            appImgAlt: appImgAlt,
            date: afterRoutes[0].date,
            userName: Username()
        };
    }
    navigateUser() {
        // So user did the requested action. Now redirect him to other url's if available
        reactLoader("show", "please wait...");
        let userData = parseJwt(getTokenData());
        if (userData.afterRoutes.length > 1) {
            userData.afterRoutes.splice(0, 1);
            setUserData("afterRoutes", userData.afterRoutes, true);
            setTimeout(() => {
                reactLoader("hide");
                this.props.router.push(userData.afterRoutes[0].url);
            }, 1200);
        } else {
            setUserData("globalAccess", true, true);
            setTimeout(() => {
                setUserData("afterRoutes", [], true);
            }, 500);
            setTimeout(() => {
                reactLoader("hide");
                this.props.router.push(routeAfterLogin);
            }, 1200);
        }
    }
    componentDidMount() {
        var player = document.getElementById("birthAudioPlayer");
        player.play();
        $("#simple3D").simple3D({
            moveX: 3,
            moveY: 3,
            bgImage: true,
            targetAll: true,
            reverseX: true,
            reverseY: true
        });
        //  $("#my_audio").get(0).play();
    }
    render() {
        return (<div className="birthday-wrapper">
            <div id="simple3D">
                <div className="dot"></div>
                <div className="kinoco"></div>
                <div className="star"></div>
            </div>
            <div className="user-top">
                <div className="row">
                    <div className="logo-birthday">
                        <img src={process.env.PUBLIC_URL + '/images/logo-events.png'} alt="" title={this.state.appImgAlt} />
                    </div>

                </div>
            </div>
            <div className="main-container">
                <div className="section-demo">
                    <canvas id="demo"></canvas>
                    <div className="container balloon-con">
                        <div className="balloon">
                            <img src={process.env.PUBLIC_URL + '/images/banner.png'} alt="" title="" />
                        </div>
                        <div className="date-div">
                            <img src={process.env.PUBLIC_URL + '/images/cake.png'} alt="" title="" />
                            <span className="b-per">{this.state.userName}</span>
                            <span className="b-date">{this.state.date}</span>
                        </div>
                        <div className="bt-div">
                            <a href="javascript:void(0);" onClick={() => this.navigateUser()} className="cnt-btn">Continue</a>
                            <audio controls controlsList="nodownload" id="birthAudioPlayer" style={{ display: "none" }}><source src={process.env.PUBLIC_URL + "/audio/Karaoke.mp3"} type="audio/mpeg" /></audio>
                        </div>
                    </div>
                </div>
                {/*<audio id="my_audio" autoplay loop src={process.env.PUBLIC_URL +'/audio/Karaoke.mp3'}></audio>*/}
            </div>
        </div>);
    }
}



// WEBPACK FOOTER //
// ./src/pages/BirthdayWish.js